/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input, OnInit } from "@angular/core";
import { MerchantDetailsParentComponent } from "../../merchant-details-parent.component";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService, MerchantService, NotificationService, SharedFormService } from "../../../../services";
import { FormBuilder, FormGroup } from "@angular/forms";
import { Merchant } from "../../../../models";
import { MERCHANT_CONSTANTS } from "../../../../utils/data.rest.constants";

@Component({
  selector: "app-wp-legal-entity",
  templateUrl: "./wp-legal-entity.component.html"
})
export class WpLegalEntityComponent extends MerchantDetailsParentComponent implements OnInit {
  @Input("merchant") merchant!: Merchant;
  editable = false;
  wpLegalEntityForm!: FormGroup;
  actionInProgress = false;
  buttonName = "Update Legal Entity";

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
    merchantService: MerchantService,
    notificationService: NotificationService,
    authService: AuthService,
    private fb: FormBuilder,
    private sharedFormService: SharedFormService
  ) {
    super(router, activatedRoute, merchantService, notificationService, authService);
  }

  ngOnInit(): void {
    this.createForm();
  }

  createForm() {
    this.wpLegalEntityForm = this.fb.group({
      legalEntity: this.sharedFormService.getLegalEntity(this.merchant)
    });
  }

  setEditable(value: boolean) {
    this.editable = value;
  }

  updateLegalEntity(): void {
    if (this.legalEntityFormGroup.valid) {
      this.actionInProgress = true;
      this.setFeeDetailsToNullIfNoneExist(this.merchant);
      const tempMerchant: Merchant = JSON.parse(JSON.stringify(this.merchant));
      this.sharedFormService.updateLegalEntity(tempMerchant, this.legalEntityFormGroup);
      tempMerchant.statementOptions = {};
      if (!this.authService.getUserRole(MERCHANT_CONSTANTS.FINANCE)) {
        tempMerchant.contractedRates = null as any;
      }
      this.merchantService.updateElementMerchant("LEGAL_ENTITY", tempMerchant).subscribe(
        (merchant) => {
          this.merchant = merchant;
          this.editable = false;
          this.actionInProgress = false;
        },
        (error) => {
          this.notificationService.error(error.error);
          this.actionInProgress = false;
        }
      );
    } else {
      this.legalEntityFormGroup.markAllAsTouched();
    }
  }

  receiveEditEvent(value: boolean) {
    this.editable = value;
    this.createForm();
  }

  get legalEntityFormGroup(): FormGroup {
    return this.wpLegalEntityForm.controls["legalEntity"] as FormGroup;
  }
}
